import gql from 'graphql-tag';

import { Group } from './group';
import PublicUserProfile from './public_user_profile';
import ClientDepartment from './client_department';
import ClientLocation from './client_location';

export default gql`
  fragment ClientFollowMapping on ClientFollowMapping {
    id
    title
    mapping_status
    all_users
    required_groups {
      ...Group
    }
    suggested_groups {
      ...Group
    }
    required_users {
      ...PublicUserProfile
    }
    suggested_users {
      ...PublicUserProfile
    }
    follow_conditions {
      department_id
      departments {
        ...ClientDepartment
      }
      location_id
      locations {
        ...ClientLocation
      }
      language
      email_domain
    }
  }
  ${Group}
  ${PublicUserProfile}
  ${ClientDepartment}
  ${ClientLocation}
`;
